import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify';
import router from './router'
import store from './store'
import DialogComponent from './components/globals/confirmDialog.vue'
import DMYDialog from './components/globals/DMYDateDialog.vue'

Vue.config.productionTip = false
Vue.component('ConfirmDialog', DialogComponent)
Vue.component('DMYDialog', DMYDialog)

new Vue({
  vuetify,
  router,
  store,
  render: h => h(App)
}).$mount('#app')
